<script lang="ts">
export default {
  name: 'ProgressBar',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    value?: number;
    max?: number;
    indeterminate?: boolean;
    class?: string;
  }>(),
  {
    value: 0,
    max: 100,
    indeterminate: false,
  }
);

const percentage = computed(() => {
  if (props.indeterminate) {
    return undefined;
  }
  const clampedValue = Math.min(Math.max(props.value || 0, 0), props.max || 100);
  return (clampedValue / (props.max || 100)) * 100;
});

const progressClasses = computed(() => {
  const classes = ['tw:progress'];
  
  if (props.class) {
    classes.push(props.class);
  }
  
  return classes.join(' ');
});
</script>

<template>
  <progress
    :class="progressClasses"
    :value="props.indeterminate ? undefined : props.value"
    :max="props.max"
    :style="props.indeterminate ? undefined : { '--progress-value': `${percentage}%` }"
  >
    {{ props.indeterminate ? '' : `${Math.round(percentage || 0)}%` }}
  </progress>
</template>
